export enum SyncEACToPlanStatus {
    Scheduled = -2,
    InProgress = -1,
    Failed = 0,
    Success = 1,
    ValidationFailed = 2
}